export default "__VITE_ASSET__82f475e0__"